var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgPandaLadder = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1021px",
    height: "983px",
    viewBox: "0 0 1021 983",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Panda_Landing") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M151.996564,169.908866 C236.020682,169.908866 300.673088,89.7976419 258.752786,19.4050523 C216.832484,-50.9875373 125.005925,93.2908389 102.632525,86.4597224 C80.2591246,79.6286059 0,38.201025 0,77.0859603 C0,115.970896 67.972447,169.908866 151.996564,169.908866 Z",
    id: "path-1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.167647,4.27796051 C69.167647,4.27796051 54.2157409,16.3177694 29.8142453,14.3151637 C5.41274972,12.312558 0,22.3474745 0,22.3474745 C0,22.3474745 0,32.9658247 0,54.202525 C32.2986385,53.3167817 49.9477943,55.94349 52.9474674,62.0826499 C61.4409503,79.4654941 51.0206548,99.6488071 44.7238669,111.807025 C41.6972753,117.65095 34.555207,119.604289 20.8211677,127.507408 C7.0871284,135.410528 10.6178431,167.372584 8.82432297,173.954293 C5.37088637,186.627426 0.988458211,195.658763 24.0510185,213.552354 C47.1135788,231.445944 56.6364237,233.689114 69.167647,238.592225 C81.6988703,243.495336 105.221249,249.680692 117.850979,254.438552 C130.480709,259.196412 137.888015,268.991976 145.513446,278.198121 C153.138877,287.404266 162.20242,296.018243 170.691168,312.588803 C179.179916,329.159363 188.36715,339.016274 206.321168,332.894114 C224.275186,326.771953 216.533412,299.477068 216.533088,287.404266 C216.532872,279.355731 211.17944,251.540294 200.472791,203.957955 L200.472791,140.5718 C195.149489,106.198608 189.138006,82.0103077 182.438344,68.0068975 C175.738681,54.0034873 184.489447,45.0385923 208.690642,41.1122125 L176.430736,7.69524178 L115.638715,0 C84.658003,2.85197367 69.167647,4.27796051 69.167647,4.27796051 Z",
    id: "path-3"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "old-designs",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "User_Dashboard-1-Copy",
    transform: "translate(-306.000000, -1198.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Panda_Landing",
    transform: "translate(306.000000, 1198.113113)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    x: 0,
    y: 3.8868872,
    width: 997,
    height: 979
  }), /*#__PURE__*/React.createElement("g", {
    id: "Panda_Ladder",
    transform: "translate(57.057499, 0.000000)"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-31-Copy",
    fill: "#80DDE5",
    opacity: 0.566731771,
    transform: "translate(481.634780, 482.568644) rotate(73.000000) translate(-481.634780, -482.568644) ",
    points: "387.55371 97.1817522 590.710206 330.804495 868.428235 313.164714 670.445138 576.188244 658.652439 867.955536 471.290529 712.519296 209.264751 802.612678 264.042114 568.206101 94.8413237 398.705774 317.170206 327.39582"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Ladder_Behind",
    fill: "#00A2AE",
    transform: "translate(453.972313, 798.903162) rotate(7.000000) translate(-453.972313, -798.903162) ",
    points: "287.972313 764.635826 619.972313 764.593947 619.698912 833.212376 290.764136 807.768839"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Body",
    transform: "translate(336.121334, 459.886887)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-10",
    transform: "translate(167.941988, 84.529686)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("use", {
    id: "Mask",
    fill: "#E6682E",
    xlinkHref: "#path-1"
  }), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask-2)",
    fill: "#AB340A",
    id: "Oval"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-45.814862, -43.417474)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M88.8149499,225.598534 C96.1949131,218.808476 94.4502004,170.987447 116.220902,146.005869 C137.991604,121.024291 162.370122,112.658885 150.115391,108.439243 C134.757906,103.151236 88.2547813,81.5092392 77.6266205,83.4793572 C52.6004411,88.1184032 33.6860633,115.442548 27.3508843,129.317854 C20.4998,144.323095 16.4634325,182.007431 23.1289692,194.838035 C34.4577443,216.644986 82.4519286,231.452937 88.8149499,225.598534 Z",
    transform: "translate(86.563516, 155.118740) rotate(-19.000000) translate(-86.563516, -155.118740) "
  }), /*#__PURE__*/React.createElement("path", {
    d: "M223.261227,254.336212 C227.27093,247.543617 208.450366,167.731948 220.277294,142.74123 C232.104221,117.750511 249.948323,103.849987 243.285051,99.6293847 C234.934715,94.3401752 216.356879,88.0913504 210.579837,90.0625157 C196.97661,94.7040278 176.967057,110.206534 162.654109,140.438817 C148.34116,170.671099 137.397596,205.535437 144.116018,215.045199 C158.001826,234.700223 219.804051,260.192804 223.261227,254.336212 Z",
    transform: "translate(193.409890, 172.440141) rotate(-42.000000) translate(-193.409890, -172.440141) "
  }), /*#__PURE__*/React.createElement("path", {
    d: "M323.011151,151.602163 C327.020855,144.809567 336.493857,95.6523862 348.320784,70.6616678 C360.147711,45.6709493 326.232807,27.2604551 319.569534,23.0398529 C311.219199,17.7506434 294.884259,12.9538116 289.107217,14.9249769 C275.50399,19.566489 250.811021,20.533282 246.618023,73.0775978 C242.425025,125.621914 267.57183,153.922148 271.199483,166.756792 C277.365058,188.57061 319.553975,157.458754 323.011151,151.602163 Z",
    transform: "translate(298.475566, 94.444591) rotate(-42.000000) translate(-298.475566, -94.444591) "
  })))), /*#__PURE__*/React.createElement("mask", {
    id: "mask-4",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-3"
  })), /*#__PURE__*/React.createElement("use", {
    id: "Mask",
    fill: "#DF6B2A",
    xlinkHref: "#path-3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.964666,278.198121 C148.279608,278.198121 167.656871,243.295619 167.656871,176.018509 C167.656871,108.741399 165.607333,44.3642008 104.328908,44.3642008 C85.6556026,44.3642008 88.3423995,78.3411466 83.7702663,94.7754758 C77.392275,117.700881 52.9474674,180.022372 52.9474674,203.957955 C52.9474674,254.807746 105.649725,278.198121 126.964666,278.198121 Z",
    id: "Oval",
    fill: "#FEEFDE",
    mask: "url(#mask-4)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval",
    fill: "#6F1703",
    mask: "url(#mask-4)",
    cx: 198.5,
    cy: 305,
    rx: 41.5,
    ry: 30
  })), /*#__PURE__*/React.createElement("g", {
    id: "Ear_L",
    transform: "translate(392.168156, 308.659787) rotate(-104.000000) translate(-392.168156, -308.659787) translate(357.520678, 273.901441)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M35.6709186,50.6862199 C52.3752905,42.4650971 63.7360743,12.8783758 60.351964,8.17855342 C56.9678537,3.47873104 30.2635324,5.48392722 13.2075528,9.92551967 C-3.84842691,14.367124 5.88639592,27.9834366 12.6337264,40.9362734 C19.3810568,53.8891103 18.9665467,58.9073426 35.6709186,50.6862199 Z",
    id: "Oval",
    fill: "#AB340A",
    transform: "translate(32.318016, 30.087320) rotate(5.000000) translate(-32.318016, -30.087320) "
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.9090522,17.6112107 C58.7492474,25.4192063 2.10612768,53.7733971 10.0906488,67.3940789 C18.0751699,81.0147607 79.5917921,25.2588473 67.7978831,8.8966038 C56.0039741,-7.46563972 -3.53306727,1.73733814 0.165096274,12.6002572 C3.86325981,23.4631762 51.0688571,9.80321502 54.9090522,17.6112107 Z",
    id: "Oval",
    fill: "#FEEFDE"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Face",
    transform: "translate(343.942501, 301.886887)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M107.200372,177 C144.007991,177 172.137514,157.350781 198.784965,140.720926 C206.915029,135.647203 223.514086,116.513323 223.514086,105.60581 C223.514086,94.698296 208,91.7787216 208,84.4661242 C208,38.8426627 162.519191,0 107.200372,0 C63.3692236,0 33.1383662,10.6991343 19.5553375,46.109297 C18.1194037,49.8526925 1.33951802,58.8066859 0.215843503,65.6182596 C-1.44629412,75.6939288 7.03679093,88.7386307 7.03679093,94.3914153 C7.03679093,140.014877 51.8815538,177 107.200372,177 Z",
    id: "Oval",
    fill: "#DE6E2F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.7688479,169.900388 C118.639036,178.352572 168.243662,169.502448 175.473466,134.570214 C182.703269,99.637979 165.792933,77.8104723 113.761818,71.9753071 C110.577474,71.6181905 103.666458,101.539121 91.2502374,107.702652 C81.9743658,112.307283 66.5033173,93.5664723 64.121899,93.6341185 C58.6322597,93.7900563 54.5941558,55.9350373 50.655767,55.9350373 C18.7546449,55.9350373 5.43815977,72.023541 5.43815977,93.6341185 C5.43815977,121.069849 24.8986595,161.448205 71.7688479,169.900388 Z",
    id: "Oval",
    fill: "#FEEFDE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.1748876,162.853711 C113.942886,162.853711 137.638518,157.052886 148.012839,142.392385 C154.186708,133.667764 152.422983,121.869195 152.422983,106.112904 C152.422983,83.4731403 157.052241,55.9350373 122.337001,55.9350373 C99.3663492,55.9350373 82.1714057,111.253185 67.4843364,99.637979 C34.3672151,73.4474447 82.4137446,52.4064141 56.7334452,41.2665529 C40.3139442,34.143935 10.4952079,77.8568155 13.7516679,106.112904 C17.7401761,140.720926 47.0720783,162.853711 88.1748876,162.853711 Z",
    id: "Oval",
    fill: "#AB340A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.4843364,133.315724 C83.245564,133.315724 95.4074106,127.220668 95.4074106,109.032937 C95.4074106,90.8452056 85.7846027,70.5904457 67.4843364,66.9378037 C49.1840701,63.2851617 24.7512032,84.0393164 24.7512032,102.227048 C24.7512032,120.414779 51.7231088,133.315724 67.4843364,133.315724 Z",
    id: "Oval",
    fill: "#FEEFDE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.0793069,24.8711412 C68.7232283,22.500984 76.205914,23.9637942 76.205914,18.0979448 C76.205914,12.2320955 64.6801398,13.4757745 53.4750255,15.2998831 C42.2699111,17.1239917 33.7508354,25.2674948 37.5778245,30.9363152 C41.4048136,36.6051356 51.4353855,27.2412983 60.0793069,24.8711412 Z",
    id: "Oval",
    fill: "#FEEFDE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.3153797,94.3855774 C69.6595591,94.3855774 74.3358632,91.3103901 74.3358632,86.378124 C74.3358632,81.4458579 69.1508171,76.5813664 61.3153797,74.8682029 C53.4799424,73.1550393 46.3035366,78.612793 46.3035366,83.5450591 C46.3035366,88.4773252 52.9712004,94.3855774 61.3153797,94.3855774 Z",
    id: "Oval",
    fill: "#232323"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M158.602477,55.9350373 C164.72595,63.7820084 168.36223,74.7799102 173.85461,71.5967608 C179.346991,68.4136113 174.850562,49.0807938 169.489548,44.718973 C164.128534,40.3571521 148.258132,31.8776134 145.471625,39.9828398 C142.685118,48.0880661 152.479004,48.0880661 158.602477,55.9350373 Z",
    id: "Oval",
    fill: "#FEEFDE"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval",
    fill: "#232323",
    cx: 125,
    cy: 83,
    rx: 9,
    ry: 11
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval",
    fill: "#232323",
    transform: "translate(39.281932, 64.194140) rotate(22.000000) translate(-39.281932, -64.194140) ",
    cx: 39.281932,
    cy: 64.1941399,
    rx: 6,
    ry: 8.5
  })), /*#__PURE__*/React.createElement("g", {
    id: "Ear_R",
    transform: "translate(506.942501, 309.886887)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M49.0894161,72.5923012 C53.1788323,68.7184782 92.2109159,20.2360136 88.2887752,14.550402 C84.3666346,8.86479044 28.2748131,11.0004885 19.0403276,15.257714 C9.80584212,19.5149394 30.0647869,31.4731075 35.5,42.0762911 C40.9352131,52.6794747 45,76.4661242 49.0894161,72.5923012 Z",
    id: "Oval",
    fill: "#AB340A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.3897975,14.550402 C106.242434,14.550402 22.491323,68.6121859 41.1361508,79.8717292 C59.7809787,91.1312725 115.869,14.6368447 101.744266,5.05263099 C87.6195315,-4.53158273 -5.57323442,-0.886957442 0.262687938,19.4793325 C6.0986103,39.8456225 44.5371608,14.550402 75.3897975,14.550402 Z",
    id: "Oval",
    fill: "#FEEFDE"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Ladder",
    transform: "translate(273.234280, 365.886887)",
    fill: "#00A2AE"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M344.881422,132.853346 L337.663859,179.303589 L17.4989878,158.222191 L14.2269734,140.202913 L344.881422,132.853346 Z",
    id: "Rectangle",
    stroke: "#00A2AE",
    strokeWidth: 19,
    transform: "translate(179.451128, 156.229000) rotate(-8.000000) translate(-179.451128, -156.229000) "
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.57572315,84.418869 L36.3439868,72.1767913 C40.4094724,70.4467602 45.1076669,72.3400201 46.837698,76.4055057 C47.2592186,77.3960577 47.4764852,78.4614944 47.4764852,79.5380041 L47.4764852,519.738284 C47.4764852,524.156562 43.8947632,527.738284 39.4764852,527.738284 C38.7471622,527.738284 38.0212645,527.638553 37.318965,527.441862 L8.55070134,519.384812 C5.09626707,518.417338 2.70822154,515.26859 2.70822154,511.681234 L2.70822154,91.7800818 C2.70822154,88.5724058 4.62417496,85.674874 7.57572315,84.418869 Z",
    id: "Rectangle"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M318.569743,18.590593 L357.926972,3.99752491 C362.069647,2.46148336 366.673157,4.57457734 368.209198,8.71725243 C368.539245,9.60738266 368.708222,10.5491531 368.708222,11.4985017 L368.708222,589.285905 C368.708222,593.704183 365.1265,597.285905 360.708222,597.285905 C360.193347,597.285905 359.679675,597.2362 359.174352,597.137481 L319.817123,589.448726 C316.061234,588.714983 313.350992,585.424039 313.350992,581.59715 L313.350992,26.0915698 C313.350992,22.7459776 315.432842,19.7537087 318.569743,18.590593 Z",
    id: "Rectangle"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M333.080692,271.311346 L338.97818,326.254455 L34.1819356,293.467121 L34.1819356,273.323929 L333.080692,271.311346 Z",
    id: "Rectangle",
    stroke: "#00A2AE",
    strokeWidth: 19
  })), /*#__PURE__*/React.createElement("g", {
    id: "Arms",
    transform: "translate(312.592923, 466.886887)",
    fill: "#6F1703"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23.1416954,64.5022445 C41.381273,64.5022445 58.0836174,48.9374954 58.0836174,34.1737796 C58.0836174,19.4100638 55.2314632,7.44170735 36.9918856,7.44170735 C18.752308,7.44170735 0,19.4100638 0,34.1737796 C0,48.9374954 4.90211784,64.5022445 23.1416954,64.5022445 Z",
    id: "Oval"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M216.192735,64.8923756 C235.045517,64.8923756 239.349578,42.3277673 239.349578,25.2727664 C239.349578,8.21776552 236.306395,0 217.453614,0 C198.600832,0 175.537254,4.37290435 175.537254,21.4279053 C175.537254,38.4829062 197.339954,64.8923756 216.192735,64.8923756 Z",
    id: "Oval"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.810896,191.507408 C50.456198,191.507408 68.2522773,169.612597 68.2522773,148.628423 C68.2522773,127.644248 46.2920436,116.579243 31.810896,121.783074 C17.3297485,126.986906 6.25227732,135.023233 6.25227732,156.007408 C6.25227732,176.991583 13.1655941,191.507408 31.810896,191.507408 Z",
    id: "Oval"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "lines",
    transform: "translate(276.811409, 214.791773) rotate(-8.000000) translate(-276.811409, -214.791773) translate(85.996509, 65.739830)",
    strokeLinecap: "round",
    strokeWidth: 6
  }, /*#__PURE__*/React.createElement("path", {
    d: "M296.637708,82.5740012 C310.231057,71.2467192 334.136377,48.7765653 368.353669,15.1635394",
    id: "Path-3",
    stroke: "#00A2AE",
    strokeLinejoin: "round",
    transform: "translate(332.495688, 48.868770) rotate(-40.000000) translate(-332.495688, -48.868770) "
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.387273,94.024653 C140.980622,82.697371 163.585713,64.9397907 195.202546,40.751912",
    id: "Path-3",
    stroke: "#00A2AE",
    strokeLinejoin: "round",
    transform: "translate(161.294909, 67.388283) rotate(-80.000000) translate(-161.294909, -67.388283) "
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.4906529,244.188113 C26.0840021,232.860831 46.2208134,212.600622 72.9010867,183.407487",
    id: "Path-3",
    stroke: "#00A2AE",
    strokeLinejoin: "round",
    transform: "translate(42.695870, 213.797800) rotate(-130.000000) translate(-42.695870, -213.797800) "
  }), /*#__PURE__*/React.createElement("line", {
    x1: 248.789854,
    y1: 74.6341094,
    x2: 236.789854,
    y2: 27.6341094,
    id: "Path-13",
    stroke: "#007674"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 105.401599,
    y1: 139.926916,
    x2: 67.4015993,
    y2: 111.926916,
    id: "Path-13",
    stroke: "#007674"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 76.9383866,
    y1: 288.103887,
    x2: 30.9383866,
    y2: 298.103887,
    id: "Path-13",
    stroke: "#007674"
  })), /*#__PURE__*/React.createElement("g", {
    id: "shapes",
    transform: "translate(97.650933, 85.898518)"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-31",
    fill: "#F4DB6B",
    transform: "translate(94.282663, 741.408659) rotate(13.000000) translate(-94.282663, -741.408659) ",
    points: "93.8686007 689.908659 111.510779 723.845375 146.323844 729.517256 123.013157 759.243871 128.244456 790.281286 94.2835708 778.910675 60.7358401 792.908659 64.1697059 757.031467 42.2414822 729.517256 76.0870542 723.430404"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M655.729491,152.611155 C674.572283,103.73217 698.124125,71.2907208 705.017225,72.6386575 C711.910326,73.9865943 746.109657,125.317638 737.243061,170.587669 C728.376466,215.857699 687.870851,261.474604 677.970832,259.538668 C668.070812,257.602733 636.886699,201.49014 655.729491,152.611155 Z",
    id: "Path-7",
    stroke: "#00A2AE",
    strokeWidth: 3,
    transform: "translate(694.248380, 166.098190) rotate(38.000000) translate(-694.248380, -166.098190) "
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.8149511,577.110497 C86.8888907,550.97828 95.1129316,543.134046 98.7981963,543.854695 C102.483461,544.575343 116.471145,572.698979 111.730789,596.901738 C106.990433,621.104496 89.6312145,644.812232 84.3383579,643.777221 C79.0455013,642.742209 66.7410115,603.242714 76.8149511,577.110497 Z",
    id: "Path-7",
    stroke: "#00A2AE",
    strokeWidth: 3,
    transform: "translate(92.835119, 593.809917) rotate(141.000000) translate(-92.835119, -593.809917) "
  }), /*#__PURE__*/React.createElement("path", {
    d: "M711.553033,249.255107 C719.290696,215.198729 744.517358,193.30304 747.347962,194.242214 C750.178567,195.181387 760.572425,228.463921 756.931418,260.005764 C753.290412,291.547606 732.604594,315.822859 728.53922,314.473998 C724.473845,313.125137 703.81537,283.311484 711.553033,249.255107 Z",
    id: "Path-7",
    fill: "#007674",
    transform: "translate(733.765012, 254.370370) rotate(85.000000) translate(-733.765012, -254.370370) "
  }), /*#__PURE__*/React.createElement("path", {
    d: "M701.723189,354.531023 C712.878204,303.446457 749.246267,270.602923 753.327013,272.011683 C757.407758,273.420443 772.392082,323.344244 767.143019,370.657008 C761.893956,417.969772 732.07221,454.382651 726.211355,452.359359 C720.3505,450.336068 690.568174,405.615589 701.723189,354.531023 Z",
    id: "Path-7",
    fill: "#00A2AE",
    transform: "translate(733.745127, 362.203918) rotate(119.000000) translate(-733.745127, -362.203918) "
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.4709898,616.764355 C83.9891539,620.051766 105.685122,596.427811 109.52994,569.058037 C113.374758,541.688263 95.1708487,517.073631 61.866852,517.071039 C28.5628553,517.068446 14.209452,538.170057 14.2115002,564.488185 C14.2135485,590.806313 30.9528257,613.476945 57.4709898,616.764355 Z",
    id: "Oval",
    fill: "#F4DB6B",
    opacity: 0.3,
    transform: "translate(62.124491, 567.071039) rotate(20.000000) translate(-62.124491, -567.071039) "
  }), /*#__PURE__*/React.createElement("path", {
    d: "M791.689317,802.156411 C824.306659,806.199926 850.9927,777.142461 855.721826,743.47764 C860.450952,709.812818 838.060144,679.53682 797.096228,679.533631 C756.132312,679.530443 738.477626,705.485424 738.480145,737.856721 C738.482665,770.228018 759.071976,798.112896 791.689317,802.156411 Z",
    id: "Oval",
    fill: "#007674",
    opacity: 0.3,
    transform: "translate(797.413124, 741.033631) rotate(20.000000) translate(-797.413124, -741.033631) "
  }), /*#__PURE__*/React.createElement("path", {
    d: "M656.465772,837.420769 C721.822958,785.994646 785.804926,719.703939 816.848179,644.951692",
    id: "Path",
    stroke: "#00A2AE",
    strokeWidth: 3,
    opacity: 0.4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M690.698269,857.951692 C755.529394,796.027141 804.09811,744.878646 873.465772,663.306663",
    id: "Path",
    stroke: "#F4DB6B",
    strokeWidth: 3,
    opacity: 0.7
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-18",
    fill: "#00BBCB",
    transform: "translate(110.200427, 420.808822) rotate(8.000000) translate(-110.200427, -420.808822) ",
    points: "110.920409 374.308822 125.257316 406.30528 159.056344 409.283191 134.45844 434.73314 140.670788 465.870538 110.920409 452.094285 81.1683508 467.308822 87.3806987 433.294856 61.3445104 409.283191 95.143539 404.866996"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-31-Copy",
    stroke: "#F4DB6B",
    strokeWidth: 9,
    transform: "translate(191.996437, 202.399589) rotate(33.000000) translate(-191.996437, -202.399589) ",
    points: "191.526094 143.899589 211.566239 182.449062 251.111177 188.891879 224.632047 222.659004 230.574397 257.915097 191.997468 244.998967 153.889852 260.899589 157.790457 220.145886 132.881698 188.891879 171.327639 181.977688"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-31-Copy",
    fill: "#80DDE5",
    transform: "translate(287.338477, 133.895584) rotate(63.000000) translate(-287.338477, -133.895584) ",
    points: "287.081244 101.901598 298.041314 122.984526 319.668668 126.508139 305.18708 144.975574 308.436985 164.257334 287.339041 157.193428 266.497767 165.88957 268.63103 143.601135 255.008287 126.508139 276.034593 122.726729"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-31-Copy",
    fill: "#F4DB6B",
    transform: "translate(399.644662, 150.278331) rotate(-37.000000) translate(-399.644662, -150.278331) ",
    points: "399.467829 128.284345 407.002234 142.77762 421.869769 145.199897 411.914528 157.895174 414.148647 171.150251 399.64505 166.294231 385.317898 172.272317 386.784391 156.950328 377.419555 145.199897 391.873905 142.6004"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-31-Copy",
    fill: "#F4DB6B",
    transform: "translate(532.488693, 41.057925) rotate(18.000000) translate(-532.488693, -41.057925) ",
    points: "532.227392 8.55792519 543.360805 29.974299 565.330215 33.5536416 550.619587 52.3131557 553.920893 71.8998739 532.489266 64.7242459 511.318368 73.5579252 513.485371 50.9169788 499.647171 33.5536416 521.006027 29.7124246"
  })), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-31-Copy",
    stroke: "#F9DA54",
    strokeWidth: 5,
    transform: "translate(696.249297, 164.984889) rotate(123.000000) translate(-696.249297, -164.984889) ",
    points: "696.068396 142.484889 703.776144 157.31161 718.985735 159.789616 708.801455 172.776972 711.086974 186.337008 696.249693 181.369265 681.592918 187.484889 683.09315 171.810388 673.512859 159.789616 688.299759 157.130312"
  }))))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgPandaLadder);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/panda-ladder.1fe1cccb545fe188b090b7a2c2003fba.svg";